import { ApiBackendSingleResponse } from '@nf/types/api';
import { WcPromotionSpinDailyInfoResponse } from '../types';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { ApiBackendInfo } from '@/hooks/query/athena/types';

const fetchWcPromotionSpinDailyInfo = async (
	apiBackendInfo: ApiBackendInfo
): Promise<ApiBackendSingleResponse<WcPromotionSpinDailyInfoResponse>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/spin/dailyInfo`)(
		apiBackendInfo.token
	);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

export const wcPromotionSpinService = {
	fetchWcPromotionSpinDailyInfo
};